<template>
  <div class="top">
    <div class="logo">
      <img src="~@/assets/logo.png" alt="">
      <div class="title">
        <span class="chinese">浙江台州市椒江敏伟矿山机械经营部</span>
        <span>Zhejiang Taizhou Jiaojiang Minwei Mining Machinery Business Department</span>
      </div>
    </div>
    <div class="nav-box">
        <span v-for="item in nav" :key="item.name"
              :class="{active:isChecked(item)}" @click="navClick(item.path)">{{item.name}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "index",
    data(){
      return{
        nav:[
          {
            name:'首页',
            path:'/home'
          },
          {
            name:'关于我们',
            path:'/about'
          },
          {
            name:'产品中心',
            path:'/product'
          },
          {
            name:'案例中心',
            path:'/project'
          },
          {
            name:'联系我们',
            path:'/contact'
          },
        ]
      }
    },
    methods:{
      isChecked(item){
        return !item.path.indexOf(this.$route.path)
      },
      navClick(path){
        this.$router.push(path)
      }
    },
  }
</script>

<style lang="less" scoped>
  .top{
    display: flex;
    justify-content: space-between;
    background-color: #FAFAFA;
    width: 100%;
    align-items: center;
    height: 112px;
    overflow: hidden;
    .logo{
      display: flex;
      align-items: center;
      img{
        height: 60px;
        width: 200px;
        margin-right: 10px;
      }

      .title {
        display: flex;
        flex-direction: column;
        color: #000;
        .chinese {
          font-size: 36px;
        }
      }
    }
    .nav-box{
      display: flex;
      font-size: 26px;
      justify-content: space-evenly;
      span{
        padding: 0 16px;
        /*不同浏览器的渐变效果*/
        -webkit-transition: all .5s;
        -moz-transition: all .5s;
        -o-transition: all .5s;
        transition: all .5s;
      }
    }
    .nav-box :hover{
      color: #3a8ee6;
      cursor:pointer;
    }
    .active{
      color: #3a8ee6;
    }
  }





</style>
